export default "__VITE_ASSET__CDS8jxAa__"